module.exports = __webpack_public_path__ + "static/media/schedules-white.27755720.svg";